var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "footer" }, [
      _c("div", { staticClass: "container footer__container" }, [
        _c("a", { staticClass: "logo logo--footer", attrs: { href: "/" } }),
        _vm._v(" "),
        _c(
          "nav",
          { staticClass: "footer-menu__wrap hidden-xs hidden-sm hidden-md" },
          [
            _c("ul", { staticClass: "footer-menu__list column" }, [
              _c("li", { staticClass: "footer-menu__item" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "footer-text text-uppercase footer-menu__item__link",
                    attrs: {
                      href: "https://support.ringba.com/",
                      target: "_BLANK"
                    }
                  },
                  [_vm._v("Support")]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "footer-menu__item" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "footer-text text-uppercase footer-menu__item__link",
                    attrs: {
                      href: "https://www.ringba.com/glossary",
                      target: "_BLANK"
                    }
                  },
                  [_vm._v("Glossary")]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "footer-menu__item" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "footer-text text-uppercase footer-menu__item__link",
                    attrs: {
                      href: "https://www.ringba.com/blog",
                      target: "_BLANK"
                    }
                  },
                  [_vm._v("Blog")]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "footer-menu__item" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "footer-text text-uppercase footer-menu__item__link",
                    attrs: {
                      href: "https://developers.ringba.com/",
                      target: "_BLANK"
                    }
                  },
                  [_vm._v("Developers")]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "footer-menu__item" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "footer-text text-uppercase footer-menu__item__link",
                    attrs: {
                      href: "http://status.ringba.com",
                      target: "_BLANK"
                    }
                  },
                  [_vm._v("System Status")]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "footer-menu__item" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "footer-text text-uppercase footer-menu__item__link",
                    attrs: {
                      href: "https://www.ringba.com/terms",
                      target: "_BLANK"
                    }
                  },
                  [_vm._v("Terms")]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "footer-menu__item" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "footer-text text-uppercase footer-menu__item__link",
                    attrs: {
                      href: "https://www.ringba.com/privacy",
                      target: "_BLANK"
                    }
                  },
                  [_vm._v("Privacy")]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "footer-menu__item" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "footer-text text-uppercase footer-menu__item__link",
                    attrs: {
                      href: "https://www.ringba.com/abuse",
                      target: "_BLANK"
                    }
                  },
                  [_vm._v("Abuse")]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "contact__wrap" }, [
          _c("h4", { staticClass: "footer-text text-uppercase hidden-xs" }, [
            _vm._v("\n        Call us\n      ")
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "call__link", attrs: { href: "tel:18008245000" } },
            [_vm._v("(800) 824-5000")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "social__wrap" }, [
          _c("h4", { staticClass: "footer-text text-uppercase hidden-xs" }, [
            _vm._v("\n        Follow us\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "social-list" }, [
            _c(
              "a",
              {
                staticClass: "social-item",
                attrs: {
                  href: "https://www.facebook.com/ringba/",
                  target: "_BLANK",
                  title: "facebook"
                }
              },
              [_c("i", { staticClass: "fa fa-facebook" })]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "social-item",
                attrs: {
                  href: "http://www.twitter.com/ringba",
                  target: "_BLANK",
                  title: "twitter"
                }
              },
              [_c("i", { staticClass: "fa fa-twitter" })]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "social-item",
                attrs: {
                  href:
                    "https://www.youtube.com/channel/UC4fdyv_T6PJMmaFBFJZpQRg",
                  target: "_BLANK",
                  title: "youtube"
                }
              },
              [_c("i", { staticClass: "fa fa-youtube" })]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "social-item",
                attrs: {
                  href: "https://www.linkedin.com/company/ringba/",
                  target: "_BLANK",
                  title: "linkedin"
                }
              },
              [_c("i", { staticClass: "fa fa-linkedin" })]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }